import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Categorytable from '../components/Categorytable';
import AdminChange from '../components/AdminChange';
import Sidebar from '../components/Sidebar';
import RecycleBin from '../components/RecycleBin';
import '../css/main.css';
import UserTable from '../components/UserTable';

const Setting = () => {
  const [activeTab, setActiveTab] = useState('category'); // default tab

  return (
    <div className="container-dash bg-gray-50 min-h-screen">
      <div className='flex'>
        <Sidebar />
        <div className='w-full'>
          <Navbar />

          <div className='flex ml-10 mt-5 mb-5 shadow-lg'>
            <div className='block p-4 bg-gray-100  h-screen p-3 pr-0'>
              <button
                onClick={() => setActiveTab('category')}
                className={`px-6 py-3 pr-14 mb-2  text-sm font-medium w-35 rounded-l-lg whitespace-nowrap ${
                  activeTab === 'category' ? 'bg-white text-gray-700' : 'bg-gray-100 text-gray-700 hover:bg-white hover:text-gray-700'
                }`}
              >
               Add Category
              </button>
              <div></div>
              <button
                onClick={() => setActiveTab('admin')}
                className={`px-6 py-3 pr-14 mb-2  text-sm font-medium w-35 rounded-l-lg ${
                  activeTab === 'admin' ? 'bg-white text-gray-700' : 'bg-gray-100 text-gray-700 hover:bg-white hover:text-gray-700'
                }`}
              >
                Admin 
              </button>
              <div></div>
              <button
                onClick={() => setActiveTab('users')}
                className={`px-6 py-3 pr-14 mb-2  text-sm font-medium w-35 rounded-l-lg ${
                  activeTab === 'users' ? 'bg-white text-gray-700' : 'bg-gray-100 text-gray-700 hover:bg-white hover:text-gray-700'
                }`}
              >
                Users 
              </button>
              <div></div>
              <button
                onClick={() => setActiveTab('recycle')}
                className={`px-6 py-3 pr-14 mb-2  text-sm font-medium w-35 rounded-l-lg whitespace-nowrap ${
                  activeTab === 'recycle' ? 'bg-white text-gray-700' : 'bg-gray-100 text-gray-700 hover:bg-white hover:text-gray-700'
                }`}
              >
                Recycle Bin 
              </button>
          </div>
          {/* Conditional Rendering */}
          <div className='p-4 bg-white  w-[81%]  '>
            {activeTab === 'category' && <Categorytable />}
            {activeTab === 'admin' && <AdminChange />}
            {activeTab === 'users' && <UserTable />}
            {activeTab === 'recycle' && <RecycleBin />}
          </div>

          </div>

          {/* Toggle Buttons */}
          

          
        </div>
      </div>
    </div>
  );
};

export default Setting;
